module.exports = __webpack_public_path__ + "img/project_icn.ad212417.svg";